import React from 'react';
import { FormCheckbox } from 'components/form';
import { Stack } from '@mui/material';
import { StageChecklistAttribute, StageChecklistAttributeItem } from '../../../types';

interface Props {
  isLoading: boolean;
  attribute: StageChecklistAttribute;
  onChange: (attributeItem: StageChecklistAttributeItem, nextValue: boolean) => void;
}

export const Checklist = ({ onChange, attribute, isLoading }: Props) => {
  return (
    <Stack gap="0.5rem" sx={{ padding: '3px' }}>
      {attribute.value.map(attributeItem => (
        <FormCheckbox
          disabled={isLoading}
          key={attributeItem.name}
          label={attributeItem.name}
          checked={attributeItem.value}
          required={attributeItem?.isRequired ?? false}
          onChange={(_, checked) => onChange(attributeItem, checked)}
        />
      ))}
    </Stack>
  );
};
